//import AbstractRestApi from '@/api/RestApi/AbstractRestApi'
import ResponseHandler from '@/api/response/ResponseHandler'
import apiClient from '@/api/ApiClient'

class NotificationsApiClient {
    getBaseUrl() {
        return '/api/v1/notification'
    }
    register(token) {
        return ResponseHandler.handle(
            apiClient.post(this.getBaseUrl() + '/register', {
                deviceToken: token,
            })
        )
    }
    test() {
        return ResponseHandler.handle(
            apiClient.get(`api/v1/test-push-notification/new-order/50395`)
        )
    }
    testApprove() {
        return ResponseHandler.handle(
            apiClient.get(`api/v1/test-push-notification/order-accepted/50395`)
        )
    }
}

export default new NotificationsApiClient()
//{"deviceToken":"cl1KHe_AWcYvyiUOLzJk-p:APA91bGFqjdu1VYgztAbPmtbQS8nZww53rsREORhVmBx9AdPFdtFk-6tU-dy-lf0m5oevOWxLKba6ZijdEB3HU9iH5tnYPtEaUI6OQQdJa7gJMfDkjT_7z0iTrZP-tKJu6qoO74rc7RP"}
//{"deviceToken":"cl1KHe_AWcYvyiUOLzJk-p:APA91bGFqjdu1VYgztAbPmtbQS8nZww53rsREORhVmBx9AdPFdtFk-6tU-dy-lf0m5oevOWxLKba6ZijdEB3HU9iH5tnYPtEaUI6OQQdJa7gJMfDkjT_7z0iTrZP-tKJu6qoO74rc7RP"}
